<template>


  <div class="row" v-if="this.$gate.areFirmaSelectata()"> <!-- <div class="row" v-if="$gate.isAdmin()"> -->

    <div class="toolbar py-6">
      <div class="container-fluid d-flex align-items-center">
        <div class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
          <span class="h-20px border-gray-200 border-start mx-3"></span>
          <ol class="breadcrumb breadcrumb-dot text-muted fs-6 fw-semibold">
            <li class="breadcrumb-item pe-3"><a @click="$router.go(-1)" style="cursor: pointer;" class="pe-3">Înapoi</a>
            </li>
            <li class="breadcrumb-item pe-3 text-muted">Adauga factura</li>
          </ol>
          <span class="h-20px border-gray-200 border-start mx-3"></span>
        </div>
      </div>
    </div>

    <div v-if="!this.$gate.firmaActiva()" class="alert alert-warning text-center my-10">
      <h4 class="mb-2"><i class="fas fa-exclamation-triangle text-warning me-2"></i> Firma nu este activă</h4>
      <p>Nu poți accesa facturile până ce firma nu este validată.</p>
    </div>

    <div class="content d-flex flex-column flex-column-fluid" v-if="this.$gate.firmaActiva()">
      <AdaugaFactura v-if="afiseazaFormularFactura" v-model:afiseazaLista="afiseazaTabel"
        @renuntaFactura="handleRenuntaFactura" />
      <!-- Facturare Table Card -->
      <div class="container-fluid mb-12" v-if="afiseazaTabel">
        <div class="card card-flush">
          <div class="card-header align-items-center py-5 gap-2 gap-md-5">
            <div class="card-title">
              <div class="d-flex align-items-center position-relative my-1">
                <h3 class="card-title">Lista facturi</h3>
              </div>
            </div>
            <div class="card-toolbar flex-row-fluid justify-content-end gap-5">
              <div class="input-group w-250px">

              </div>
              <div class="w-100 mw-150px">

              </div>
              <a href="#" class="btn btn-primary" @click="afiseazaFormularFactura = true;">Adaugă factura</a>
              <button type="button" class="btn btn-light-success ms-2" :disabled="importIesiriBusy"
                @click="importaIesiriDinAnaf()">
                Importă facturi trimise (ANAF)
                <span v-if="importIesiriBusy" class="spinner-border spinner-border-sm ms-2" role="status"
                  aria-hidden="true"></span>
              </button>
              <div class="ms-2" ref="bulkMenuRef">
                <button type="button" class="btn rotate"
                  :class="(selectedIds.length === 0) ? 'btn-secondary' : (canBulkUpload ? 'btn-success' : 'btn-secondary')"
                  :disabled="bulkBusy || (selectedIds.length > 0 && !canBulkUpload)" data-kt-menu-trigger="click"
                  data-kt-menu-placement="bottom-start" data-kt-menu-offset="0, 8" @click="onBulkButtonClick($event)">
                  Încarcă selectate (TEST)<span v-if="selectedIds.length > 0 && canBulkUpload"> ({{ selectedIds.length
                    }})</span>
                  <span class="fas fa-chevron-down rotate-180 ms-3 me-0"></span>
                  <span v-if="bulkBusy" class="spinner-border spinner-border-sm ms-2" role="status"
                    aria-hidden="true"></span>
                </button>
                <div
                  class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-auto min-w-200 mw-300px"
                  data-kt-menu="true">
                  <div class="menu-item px-3">
                    <div class="menu-content fs-6 text-gray-900 fw-bold px-3 py-3">Selectare rapidă</div>
                  </div>
                  <div class="separator mb-3 opacity-75"></div>
                  <div class="menu-item px-3"><a href="#" class="menu-link px-3"
                      @click.prevent="selectUploadAll">Selectează Toate</a></div>
                  <div class="menu-item px-3"><a href="#" class="menu-link px-3"
                      @click.prevent="selectUploadNetransmise">Selectează Netransmise</a></div>
                  <div class="menu-item px-3"><a href="#" class="menu-link px-3"
                      @click.prevent="selectUploadEroareXML">Selectează Eroare XML</a></div>
                  <div class="menu-item px-3"><a href="#" class="menu-link px-3"
                      @click.prevent="selectUploadEroareTrimitere">Selectează Eroare Trimitere</a></div>
                  <div class="menu-item px-3"><a href="#" class="menu-link px-3"
                      @click.prevent="selectUploadNOK">Selectează NOK</a></div>
                </div>
              </div>

              <div class="ms-2" ref="statusMenuRef">
                <button type="button" class="btn rotate"
                  :class="(selectedIds.length === 0) ? 'btn-secondary' : (canBulkUpdate ? 'btn-success' : 'btn-secondary')"
                  :disabled="statusBusy || (selectedIds.length > 0 && !canBulkUpdate)" data-kt-menu-trigger="click"
                  data-kt-menu-placement="bottom-start" data-kt-menu-offset="0, 8" @click="onStatusBulkClick($event)">
                  Actualizează stări<span v-if="selectedIds.length > 0 && canBulkUpdate"> ({{ selectedIds.length
                    }})</span>
                  <span class="fas fa-chevron-down rotate-180 ms-3 me-0"></span>
                  <span v-if="statusBusy" class="spinner-border spinner-border-sm ms-2" role="status"
                    aria-hidden="true"></span>
                </button>
                <div
                  class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-auto min-w-200 mw-300px"
                  data-kt-menu="true">
                  <div class="menu-item px-3">
                    <div class="menu-content fs-6 text-gray-900 fw-bold px-3 py-3">Selectare rapidă</div>
                  </div>
                  <div class="separator mb-3 opacity-75"></div>
                  <div class="menu-item px-3"><a href="#" class="menu-link px-3"
                      @click.prevent="selectForStatusUpdate">Selectează tot</a></div>
                  <div class="menu-item px-3"><a href="#" class="menu-link px-3"
                      @click.prevent="selectOnlyIncarcate">Selectează încărcate</a></div>
                  <div class="menu-item px-3"><a href="#" class="menu-link px-3"
                      @click.prevent="selectOnlyPrelucrare">Selectează în prelucrare</a></div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div id="tabel_facturare_wrapper" class="table table-bordered table-striped">
              <div class="table-responsive">
                <!-- Update table class and layout to restore Excel-like appearance -->
                <table class="table table-bordered table-striped nowrap" role="grid" id="tabel_facturare">
                  <thead>
                    <tr class="text-uppercase fw-bold">
                      <th class="text-center" style="width:32px">
                        <div class="form-check form-check-custom form-check-success form-check-solid d-inline-flex">
                          <input class="form-check-input" type="checkbox" :checked="selectAllVisibleChecked"
                            @change="onToggleSelectAllVisible($event)" />
                        </div>
                      </th>
                      <th></th>
                      <th>Data</th>
                      <th>Nr. doc.</th>
                      <th>Client</th>
                      <th>Valoare</th>
                      <th>TVA</th>
                      <th>Total</th>
                      <th>Stare</th>
                      <th>Sold</th>
                      <th>Scadenta</th>
                      <th>TVA-I</th>
                      <th>e-Fact</th>
                      <th>Agent</th>

                      <th>Acțiuni</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(factura) in facturi_emise" :key="factura.id">
                      <tr :class="`row-factura-${factura.id}`">
                        <td class="text-center">
                          <div class="form-check form-check-custom form-check-success form-check-solid d-inline-flex">
                            <input class="form-check-input row-select" type="checkbox" :checked="isSelected(factura.id)"
                              @change="onToggleSelect(factura.id, $event)" />
                          </div>
                        </td>
                        <td class="details-control text-center" style="cursor: pointer;"
                          @click="toggleFacturaDetails(factura)">
                          <i class="fas fa-chevron-down"
                            :class="{ 'rotate-up': expandedRows.includes(factura.id) }"></i>
                        </td>
                        <td>{{ $filters.formatDate(factura.data_doc) || '/' }}</td>
                        <td :data-order="Number(factura.nr_doc) || 0">
                          {{ factura.sd_serie }}{{ factura.nr_doc }}
                        </td>
                        <td>{{ factura.c_denumire || '/' }}</td>
                        <td class="text-end">{{ $filters.toCurrency(factura.iesiri_date_valoare) || '0.00' }}</td>
                        <td class="text-end">{{ $filters.toCurrency(factura.iesiri_date_tva) || '0.00' }}</td>
                        <td class="text-end">{{ $filters.toCurrency(factura.iesiri_date_total) || '0.00' }}</td>
                        <td>
                          <div class="progress h-30px">
                            <div class="progress-bar progress-bar-striped progress-bar text-white fw-bold fs-6 py-2"
                              :class="{
                                'bg-danger': factura.stare === 0 || !factura.stare,
                                'bg-warning': factura.stare === 1,
                                'bg-success': factura.stare === 2
                              }" role="progressbar" :style="{
                                              width: factura.stare === 0 || !factura.stare ? '100%' :
                                                factura.stare === 1 ? '75%' :
                                                  '100%'
                                            }" :aria-valuenow="factura.stare === 0 || !factura.stare ? 100 :
                                              factura.stare === 1 ? 75 : 100" aria-valuemin="0"
                              aria-valuemax="100">
                              {{ factura.stare === 0 || !factura.stare ? 'Restant' :
                                factura.stare === 1 ? 'Parțial' :
                                  'Achitat' }}
                            </div>
                          </div>
                        </td>
                        <td class="text-end">{{ $filters.toCurrency(factura.isf_sold) || '0.00' }}</td>
                        <td>{{ $filters.formatDate(factura.data_scadenta) || '/' }}</td>
                        <td class="text-center">
                          <div
                            class="form-check form-check-custom form-check-success form-check-solid d-inline-flex align-items-center mb-0">
                            <input class="form-check-input" type="checkbox" :checked="factura.tva_incasare" disabled />
                          </div>
                        </td>
                        <td>
                          <!-- Imported from ANAF badge -->
                          <div v-if="Number(factura.efactura) === 1" class="progress h-30px efact-clickable">
                            <div class="progress-bar progress-bar-striped text-white fw-bold fs-7 py-1 bg-info"
                              role="progressbar" :style="{ width: '100%' }" aria-valuenow="100" aria-valuemin="0"
                              aria-valuemax="100">
                              Importata
                            </div>
                          </div>
                          <!-- Upload progress badge (shown only when status = 1 / Transmis) -->
                          <div v-else-if="Number(factura.anaf_ft_status) === 1" class="progress h-30px efact-clickable"
                            @click="showEFactPopup(factura, 'upload')">
                            <div class="progress-bar progress-bar-striped progress-bar text-white fw-bold fs-7 py-1"
                              :class="eFactUploadBarClass(factura.anaf_ft_stare_upload)" role="progressbar"
                              :style="{ width: '100%' }" :aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">
                              {{ eFactUploadBarLabel(factura.anaf_ft_stare_upload) }}
                            </div>
                          </div>
                          <!-- Status progress badge (shown when status ≠ 1 / Netransmis sau erori) -->
                          <div v-else class="progress h-30px efact-clickable"
                            @click="showEFactPopup(factura, 'status')">
                            <div class="progress-bar progress-bar-striped progress-bar text-white fw-bold fs-7 py-1"
                              :class="eFactStatusBarClass(factura.anaf_ft_status)" role="progressbar"
                              :style="{ width: '100%' }" :aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">
                              {{ eFactStatusBarLabel(factura.anaf_ft_status) }}
                            </div>
                          </div>
                        </td>
                        <td>{{ factura.agent || '-' }}</td>
                        <td class="text-nowrap">
                          <div class="d-inline-block" :ref="`rowMenuRef-${factura.id}`">
                            <button type="button" class="btn btn-sm rotate"
                              :class="Number(factura.efactura) === 1 ? 'btn-secondary' : 'btn-primary'"
                              :disabled="Number(factura.efactura) === 1" data-kt-menu-trigger="click"
                              data-kt-menu-placement="bottom-start" data-kt-menu-offset="0, 6">
                              Acțiuni
                              <span v-if="Number(factura.efactura) !== 1"
                                class="fas fa-chevron-down rotate-180 ms-2 me-0"></span>
                            </button>
                            <button class="btn btn-sm btn-outline-primary" @click="descarcaFacturaPDF(factura.id)">
                              📄 Generează PDF
                            </button>
                            <div
                              class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-auto min-w-200 mw-300px"
                              data-kt-menu="true">
                              <div class="menu-item px-3"><a href="#" class="menu-link px-3"
                                  @click.prevent="rowActionUpload(factura.id)">Trimitere 📤</a></div>
                              <div class="menu-item px-3"><a href="#" class="menu-link px-3"
                                  @click.prevent="rowActionStare(factura.id)">Stare 🔄</a></div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End Facturare Table Card -->
    </div>

  </div>
  <!-- E-Fact Popup -->
  <div v-if="efactPopup.visible" class="efact-modal-backdrop" @click.self="efactPopup.visible = false">
    <div class="efact-modal">
      <div class="efact-modal-header d-flex justify-content-between align-items-center">
        <h5 class="mb-0">{{ efactPopup.title }}</h5>
        <button type="button" class="btn btn-sm btn-light" @click="efactPopup.visible = false">
          &times;
        </button>
      </div>
      <div class="efact-modal-body">
        <div class="mb-0" v-html="efactPopup.message"></div>
      </div>
      <div class="efact-modal-footer text-end mt-3">
        <button type="button" class="btn btn-primary btn-sm" @click="efactPopup.visible = false">Închide</button>
      </div>
    </div>
  </div>
  <div class="row" v-if="!this.$gate.areFirmaSelectata()">
    <div class="card-body p-9">
      <div class="notice d-flex bg-light-danger rounded border-warning border border-dashed p-6">
        <i class="ki-duotone ki-information fs-2tx text-danger me-4">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
        </i>
        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-semibold">
            <h4 class="text-gray-900 fw-bold">Nu aveti o firma selectata</h4>
            <div class="fs-6 text-gray-700">In cazul in care aveti o firma deja adaugata, trebuie sa selectati firma
              folosind butonul "Schimba firma" aflat in partea de sus.<br />
              In cazul in care nu aveti nicio firma adaugata, trebuie sa adaugati o firma noua pentru a putea utiliza
              modulul de facturare.
            </div>
          </div>
          <div class="d-flex align-items-center gap-2 gap-lg-3">
            <router-link to="/firmele-mele" class="btn btn-sm fw-bold btn-success">
              Adaugă firmă
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
  <IncasareModal v-if="incasareModal.visible" :factura="incasareModal.factura" :firmaId="incasareModal.firmaId"
    :clientId="incasareModal.clientId" :incasareId="incasareModal.incasareId" :mode="incasareModal.mode"
    @close="incasareModal.visible = false" @saved="incarcaTabelFacturare()" />
</template>


<script>
import $ from 'jquery'
if (!window.$) window.$ = $
if (!window.jQuery) window.jQuery = $

import DataTable from 'datatables.net-bs5'
import 'datatables.net-bs5/css/dataTables.bootstrap5.css'
// Attach the jQuery plugin if not already registered (v2 ESM)
if (typeof $.fn.dataTable === 'undefined') {
  DataTable(window, $)
}

import moment from "moment";
import draggable from 'vuedraggable';
import { createApp } from 'vue';
import FacturaChild from '../Facturi/FacturaChild.vue';
import IncasareModal from './IncasareModal.vue';

export default {
  components: {
    moment: moment,
    draggable,
    IncasareModal
  },
  data() {
    return {
      setari_select2: {
        theme: "bootstrap",
        placeholder: "Selectează din listă",
        width: "100%",
      },
      clienti: [],
      editmode: false,
      facturi_emise: [],
      afiseazaInformatii: false,
      afiseazaFormularFactura: false,
      afiseazaTabel: true,
      expandedRows: [],
      produseFacturi: {},
      efactPopup: {
        visible: false,
        title: '',
        message: ''
      },
      selectedIds: [],
      bulkBusy: false,
      selectAllVisibleChecked: false,
      showSelectMenu: false,
      statusBusy: false,
      showStatusMenu: false,
      importIesiriBusy: false,
      incasareModal: {
        visible: false,
        factura: null,
        clientId: null,
        firmaId: null,
        incasareId: null,
        mode: 'create'
      }
    }
  },

  methods: {
    deschideModalIncasare(factura) {
      this.incasareModal.mode = 'create';
      this.incasareModal.incasareId = null;
      this.incasareModal.factura = factura;
      this.incasareModal.clientId = factura.id_client;
      this.incasareModal.firmaId = factura.id_firma;
      this.incasareModal.visible = true;
    },

    deschideModalEditIncasare(incasare) {
      this.incasareModal.mode = 'edit';
      this.incasareModal.incasareId = incasare.id;
      this.incasareModal.factura = this.facturi_emise.find(f => f.id === incasare.repartizari?.[0]?.id_factura) || null;
      // If we don't have the factura in the current list, we might need to fetch it or just use basic info
      // but usually the history comes from a factura we already have open.
      this.incasareModal.clientId = incasare.id_client || this.incasareModal.factura?.id_client; 
      this.incasareModal.firmaId = incasare.id_firma || this.incasareModal.factura?.id_firma;
      this.incasareModal.visible = true;
    },

    async confirmaStergereIncasare(incasare) {
      const result = await Swal.fire({
        title: 'Ești sigur?',
        text: "Ștergerea încasării va restaura soldul facturilor repartizate și va șterge nota contabilă din Registrul Jurnal!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Da, șterge!',
        cancelButtonText: 'Anulează'
      });

      if (result.isConfirmed) {
        try {
          await axios.delete(`/api/facturare/incasari/destroy/${incasare.id}`);
          Swal.fire('Șters!', 'Încasarea a fost ștearsă.', 'success');
          this.incarcaTabelFacturare();
        } catch (e) {
          console.error(e);
          Swal.fire('Eroare', 'Nu s-a putut șterge încasarea.', 'error');
        }
      }
    },

    descarcaFacturaPDF(id) {
      const url = `/api/facturare/utils/pdf/fi/${id}`;
      window.open(url, '_blank');
    },

    async importaIesiriDinAnaf() {
      if (this.importIesiriBusy) return;

      const confirm = await Swal.fire({
        title: 'Import e-Factura (trimise)',
        text: 'Vrei să imporți facturile trimise descărcate din ANAF în Ieșiri?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Importă',
        cancelButtonText: 'Anulează',
        confirmButtonColor: '#28a745',
        cancelButtonColor: '#6c757d'
      });

      if (!confirm.isConfirmed) return;

      this.importIesiriBusy = true;
      try {
        const { data } = await axios.post('/api/anaf/efactura/sync-iesiri');

        // backend returns: { status, message, download: {...}, import: {...} }
        const dl = data?.download || null;
        const imp = data?.import || null;

        const dlMsg = dl?.message || (dl?.status ? `Download: ${dl.status}` : '');
        const impMsg = imp?.message || (imp?.status ? `Import: ${imp.status}` : '');

        const imported = Number(imp?.imported ?? imp?.imported_ok ?? 0);
        const skipped = Number(imp?.skipped_existing ?? 0);
        const errCount = Number(imp?.errors_count ?? 0);
        const attempted = Number(dl?.attempted ?? 0);
        const newDl = Number(dl?.new ?? 0);

        let title = data?.message || 'Sync e-Factura Ieșiri finalizat.';
        let toastIcon = 'success';

        if (data?.status === 'partial_success') toastIcon = 'warning';
        if (data?.status === 'error') toastIcon = 'error';

        // build a compact summary
        const parts = [];
        if (!Number.isNaN(newDl) && !Number.isNaN(attempted)) parts.push(`Download: noi ${newDl} / încercate ${attempted}`);
        if (!Number.isNaN(imported) || !Number.isNaN(skipped)) parts.push(`Import: ${imported} noi, ${skipped} existente`);
        if (errCount) parts.push(`Erori import: ${errCount}`);

        const summary = parts.length ? parts.join(' · ') : '';

        if (typeof toast !== 'undefined') {
          toast.fire({
            icon: toastIcon,
            title: summary ? `${title} — ${summary}` : title,
          });
        }

        // If backend gave a hard error message, also show a modal for clarity
        if (data?.status === 'error') {
          await Swal.fire({
            title: 'Sync e-Factura Ieșiri (eroare)',
            html: `<div class="text-start">
                        <div class="mb-2"><strong>${this.escapeHtml(title)}</strong></div>
                        ${dlMsg ? `<div class="mb-1">${this.escapeHtml(dlMsg)}</div>` : ''}
                        ${impMsg ? `<div class="mb-1">${this.escapeHtml(impMsg)}</div>` : ''}
                      </div>`,
            icon: 'error'
          });
        }

        // show errors details (if any)
        if (Array.isArray(imp?.errors) && imp.errors.length) {
          const list = imp.errors
            .slice(0, 15)
            .map(e => `• ${this.escapeHtml(e.file || 'XML')}: ${this.escapeHtml(e.error || 'eroare')}`)
            .join('<br>');
          this.efactPopup.title = 'Erori import (primele 15)';
          this.efactPopup.message = list;
          this.efactPopup.visible = true;
        }
        // refresh list
        if (typeof emitter !== 'undefined' && emitter && typeof emitter.emit === 'function') {
          emitter.emit('AfterCreate');
        }
      } catch (e) {
        const msg = e?.response?.data?.message
          || e?.response?.data?.error
          || e?.response?.data?.download?.message
          || e?.response?.data?.import?.message
          || e.message
          || 'Eroare la sync.';
        if (typeof toast !== 'undefined') toast.fire({ icon: 'error', title: msg });
      } finally {
        this.importIesiriBusy = false;
      }
    },
    initKTMenus() {
      try {
        if (window.KTMenu && typeof window.KTMenu.createInstances === 'function') {
          window.KTMenu.createInstances();
        } else if (window.KTMenu && typeof window.KTMenu.init === 'function') {
          window.KTMenu.init();
        }
      } catch (e) {
        console.warn('KTMenu init failed:', e);
      }
    },
    isEligibleForUpdate(f) {
      const status = Number(f.anaf_ft_status); // 1 = Transmis
      const upload = f.anaf_ft_stare_upload;   // poate fi null
      const uploadNum = upload == null ? null : Number(upload); // null sau 3
      return status === 1 && (upload == null || uploadNum === 3);
    },
    isEligibleForUpload(f) {
      const status = Number(f.anaf_ft_status);           // 0=Netransmis, 2=Eroare trimitere, 3=Eroare XML
      const upload = Number(f.anaf_ft_stare_upload);     // 2=NOK
      const isNetransmis = !(status === 1 || status === 2 || status === 3); // include 0/null/undefined
      const isErrTrimitere = status === 2;
      const isErrXML = status === 3;
      const isStatusRetry = isNetransmis || isErrTrimitere || isErrXML;
      const isStatus1NOK = status === 1 && upload === 2; // status=1 dar upload NOK
      return isStatusRetry || isStatus1NOK;
    },
    selectedRows() {
      // comoditate: lista obiectelor factura selectate
      const ids = new Set(this.selectedIds);
      return this.facturi_emise.filter(f => ids.has(f.id));
    },
    onStatusBulkClick(evt) {
      if (this.statusBusy) return;
      if (this.selectedIds.length > 0) {
        evt?.preventDefault?.();
        evt?.stopPropagation?.();
        Swal.fire({
          title: 'Ești sigur?',
          text: 'Vrei să actualizezi stările pentru facturile selectate?',
          icon: 'warning',
          showCancelButton: true,
          showDenyButton: true,
          confirmButtonText: 'Confirmă',
          denyButtonText: 'Deselectează',
          cancelButtonText: 'Anulează',
          confirmButtonColor: '#28a745',   // verde
          denyButtonColor: '#dc3545',      // roșu
          cancelButtonColor: '#6c757d'     // secondary
        }).then((result) => {
          if (result.isConfirmed) {
            this.bulkUpdateStatuses();
          } else if (result.isDenied) {
            this.selectedIds = [];
            this.selectAllVisibleChecked = false;
          }
        });
      } else {
        // zero selection -> let KT Menu open via data-kt-menu-trigger
      }
    },
    selectForStatusUpdate() {
      try {
        const ids = this.facturi_emise
          .filter(f => {
            const status = Number(f.anaf_ft_status);             // 1=Transmis
            const upload = f.anaf_ft_stare_upload;               // poate fi null
            const uploadNum = upload == null ? null : Number(upload);
            const isValidUpload = (upload == null) || uploadNum === 3;
            return status === 1 && isValidUpload;
          })
          .map(f => f.id)
          .filter(id => id != null);
        ids.forEach(id => { if (!this.selectedIds.includes(id)) this.selectedIds.push(id); });
        // Marchează vizual checkbox-urile pentru rândurile existente în DOM (DataTables)
        this.$nextTick(() => {
          ids.forEach(id => {
            const el = document.querySelector(`.row-factura-${id} input.row-select[type="checkbox"]`);
            if (el) el.checked = true;
          });
        });
        this.hideKtMenu('statusMenuRef');
      } catch (e) {
        console.error('selectForStatusUpdate error:', e);
        this.hideKtMenu('statusMenuRef');
      }
    },
    selectOnlyPrelucrare() {
      try {
        const ids = this.facturi_emise
          .filter(f => {
            const status = Number(f.anaf_ft_status);   // 1=Transmis
            const upload = f.anaf_ft_stare_upload;     // poate fi null
            const uploadNum = upload == null ? null : Number(upload);
            return status === 1 && uploadNum === 3;    // încărcate: upload=3
          })
          .map(f => f.id)
          .filter(id => id != null);
        // adaugă fără dubluri
        ids.forEach(id => { if (!this.selectedIds.includes(id)) this.selectedIds.push(id); });
        // marchează vizual
        this.$nextTick(() => {
          ids.forEach(id => {
            const el = document.querySelector(`.row-factura-${id} input.row-select[type="checkbox"]`);
            if (el) el.checked = true;
          });
        });
        this.hideKtMenu('statusMenuRef');
      } catch (e) {
        console.error('selectOnlyIncarcate error:', e);
        this.hideKtMenu('statusMenuRef');
      }
    },
    selectOnlyIncarcate() {
      try {
        const ids = this.facturi_emise
          .filter(f => {
            const status = Number(f.anaf_ft_status); // 1=Transmis
            const upload = f.anaf_ft_stare_upload;   // null => în prelucrare
            return status === 1 && (upload == null);
          })
          .map(f => f.id)
          .filter(id => id != null);
        // adaugă fără dubluri
        ids.forEach(id => { if (!this.selectedIds.includes(id)) this.selectedIds.push(id); });
        // marchează vizual
        this.$nextTick(() => {
          ids.forEach(id => {
            const el = document.querySelector(`.row-factura-${id} input.row-select[type="checkbox"]`);
            if (el) el.checked = true;
          });
        });
        this.hideKtMenu('statusMenuRef');
      } catch (e) {
        console.error('selectOnlyPrelucrare error:', e);
        this.hideKtMenu('statusMenuRef');
      }
    },
    async bulkUpdateStatuses() {
      if (!this.selectedIds.length) return;
      this.statusBusy = true;
      const results = { ok: 0, fail: 0, messages: [] };
      for (const id of this.selectedIds) {
        try {
          await this.verificaStareEFactura(id, false, true);
          results.ok++;
          await new Promise(r => setTimeout(r, 350));
        } catch (e) {
          results.fail++;
          results.messages.push(`ID ${id}: ${e?.response?.data?.message || e.message || 'eroare necunoscută la stare'}`);
          await new Promise(r => setTimeout(r, 350));
        }
      }
      this.statusBusy = false;
      if (typeof toast !== 'undefined') {
        toast.fire({ icon: results.fail ? 'warning' : 'success', title: `Stări actualizate — reușite: ${results.ok}, eșecuri: ${results.fail}` });
      }
      if (results.messages.length) //console.warn('Detalii actualizare stări:', results.messages);
        // reîncarcă tabelul după bulk
        if (typeof emitter !== 'undefined' && emitter && typeof emitter.emit === 'function') {
          emitter.emit('AfterCreate');
        }
    },
    onBulkButtonClick(evt) {
      if (this.bulkBusy) return;
      if (this.selectedIds.length > 0) {
        evt?.preventDefault?.();
        evt?.stopPropagation?.();
        Swal.fire({
          title: 'Ești sigur?',
          text: 'Vrei să trimiți facturile selectate?',
          icon: 'warning',
          showCancelButton: true,
          showDenyButton: true,
          confirmButtonText: 'Confirmă',
          denyButtonText: 'Deselectează',
          cancelButtonText: 'Anulează',
          confirmButtonColor: '#28a745',   // verde
          denyButtonColor: '#dc3545',      // roșu
          cancelButtonColor: '#6c757d'     // secondary
        }).then((result) => {
          if (result.isConfirmed) {
            this.uploadSelectedEFactura();
          } else if (result.isDenied) {
            this.selectedIds = [];
            this.selectAllVisibleChecked = false;
          }
        });
      } else {
        // zero selection -> let KT Menu open via data-kt-menu-trigger
      }
    },
    selectUploadAll() {
      try {
        const ids = this.facturi_emise
          .filter(f => {
            const status = Number(f.anaf_ft_status);           // 0=Netransmis, 2=Eroare trimitere, 3=Eroare XML
            const upload = Number(f.anaf_ft_stare_upload);     // 2=NOK
            const isNetransmis = !(status === 1 || status === 2 || status === 3); // include 0/null/undefined
            const isErrTrimitere = status === 2;
            const isErrXML = status === 3;
            const isStatusRetry = isNetransmis || isErrTrimitere || isErrXML;
            const isStatus1NOK = status === 1 && upload === 2; // status=1 dar upload NOK
            return isStatusRetry || isStatus1NOK;
          })
          .map(f => f.id)
          .filter(id => id != null);
        ids.forEach(id => { if (!this.selectedIds.includes(id)) this.selectedIds.push(id); });
        this.$nextTick(() => {
          ids.forEach(id => {
            const el = document.querySelector(`.row-factura-${id} input.row-select[type="checkbox"]`);
            if (el) el.checked = true;
          });
        });
        this.hideKtMenu('bulkMenuRef');
      } catch (e) {
        console.error('selectUploadAll error:', e);
        this.hideKtMenu('bulkMenuRef');
      }
    },
    selectUploadNetransmise() {
      try {
        const ids = this.facturi_emise
          .filter(f => {
            const status = Number(f.anaf_ft_status);
            // considerăm Netransmis orice NU e 1/2/3 (inclusiv 0 sau null/undefined)
            return !(status === 1 || status === 2 || status === 3);
          })
          .map(f => f.id)
          .filter(id => id != null);
        ids.forEach(id => { if (!this.selectedIds.includes(id)) this.selectedIds.push(id); });
        this.$nextTick(() => {
          ids.forEach(id => {
            const el = document.querySelector(`.row-factura-${id} input.row-select[type="checkbox"]`);
            if (el) el.checked = true;
          });
        });
        this.hideKtMenu('bulkMenuRef');
      } catch (e) {
        console.error('selectUploadNetransmise error:', e);
        this.hideKtMenu('bulkMenuRef');
      }
    },
    selectUploadEroareXML() {
      try {
        const ids = this.facturi_emise
          .filter(f => Number(f.anaf_ft_status) === 3)
          .map(f => f.id)
          .filter(id => id != null);
        ids.forEach(id => { if (!this.selectedIds.includes(id)) this.selectedIds.push(id); });
        this.$nextTick(() => {
          ids.forEach(id => {
            const el = document.querySelector(`.row-factura-${id} input.row-select[type="checkbox"]`);
            if (el) el.checked = true;
          });
        });
        this.hideKtMenu('bulkMenuRef');
      } catch (e) {
        console.error('selectUploadEroareXML error:', e);
        this.hideKtMenu('bulkMenuRef');
      }
    },
    selectUploadEroareTrimitere() {
      try {
        const ids = this.facturi_emise
          .filter(f => Number(f.anaf_ft_status) === 2)
          .map(f => f.id)
          .filter(id => id != null);
        ids.forEach(id => { if (!this.selectedIds.includes(id)) this.selectedIds.push(id); });
        this.$nextTick(() => {
          ids.forEach(id => {
            const el = document.querySelector(`.row-factura-${id} input.row-select[type="checkbox"]`);
            if (el) el.checked = true;
          });
        });
        this.hideKtMenu('bulkMenuRef');
      } catch (e) {
        console.error('selectUploadEroareTrimitere error:', e);
        this.hideKtMenu('bulkMenuRef');
      }
    },
    selectUploadNOK() {
      try {
        const ids = this.facturi_emise
          .filter(f => Number(f.anaf_ft_stare_upload) === 2) // NOK
          .map(f => f.id)
          .filter(id => id != null);
        ids.forEach(id => { if (!this.selectedIds.includes(id)) this.selectedIds.push(id); });
        this.$nextTick(() => {
          ids.forEach(id => {
            const el = document.querySelector(`.row-factura-${id} input.row-select[type="checkbox"]`);
            if (el) el.checked = true;
          });
        });
        this.hideKtMenu('bulkMenuRef');
      } catch (e) {
        console.error('selectUploadNOK error:', e);
        this.hideKtMenu('bulkMenuRef');
      }
    },
    // Helper to programmatically close Metronic KT Menu
    hideKtMenu(refName) {
      try {
        let root = this.$refs[refName];
        if (!root) return;
        // If it's an array (v-for refs), take the first element
        if (Array.isArray(root)) root = root[0];
        // If it's a Vue component, use its $el
        const rootEl = root && root.$el ? root.$el : root;
        // Ensure we have a real DOM element before querying
        if (!rootEl || typeof rootEl.querySelector !== 'function') return;

        const menuEl = rootEl.querySelector('[data-kt-menu="true"]');
        if (!menuEl) return;

        if (window.KTMenu && typeof window.KTMenu.getInstance === 'function') {
          let inst = window.KTMenu.getInstance(menuEl);
          if (!inst && typeof window.KTMenu === 'function') {
            // instantiate if not already
            inst = new window.KTMenu(menuEl);
          }
          if (inst && typeof inst.hide === 'function') inst.hide();
        } else {
          // Fallback: hide by class/style if KTMenu API not available
          menuEl.classList.remove('show');
          menuEl.style.display = 'none';
        }
      } catch (e) {
        console.warn('hideKtMenu error:', e);
      }
    },
    rowMenuRefName(id) {
      return `rowMenuRef-${id}`;
    },
    rowActionUpload(id) {
      try {
        this.uploadXMLEFactura(id);
      } finally {
        this.hideKtMenu(this.rowMenuRefName(id));
      }
    },
    rowActionStare(id) {
      try {
        this.verificaStareEFactura(id);
      } finally {
        this.hideKtMenu(this.rowMenuRefName(id));
      }
    },
    handleDocumentClick(e) {
      try {
        const bulkEl = this.$refs.bulkMenuRef;
        const statusEl = this.$refs.statusMenuRef;
        if (this.showSelectMenu && bulkEl && !bulkEl.contains(e.target)) {
          this.showSelectMenu = false;
        }
        if (this.showStatusMenu && statusEl && !statusEl.contains(e.target)) {
          this.showStatusMenu = false;
        }
      } catch { }
    },
    isSelected(id) {
      return this.selectedIds.includes(id);
    },
    onToggleSelect(id, evt) {
      const checked = !!evt.target.checked;
      if (checked) {
        if (!this.selectedIds.includes(id)) this.selectedIds.push(id);
      } else {
        this.selectedIds = this.selectedIds.filter(x => x !== id);
        this.selectAllVisibleChecked = false;
      }
    },
    getVisibleFacturaIds() {
      try {
        const table = $('#tabel_facturare').DataTable();
        const nodes = table.rows({ search: 'applied', page: 'current' }).nodes();
        const ids = [];
        $(nodes).each(function () {
          const cls = this.className || '';
          const m = cls.match(/row-factura-(\d+)/);
          if (m && m[1]) ids.push(Number(m[1]));
        });
        return ids;
      } catch { return []; }
    },
    onToggleSelectAllVisible(evt) {
      const checked = !!evt.target.checked;
      this.selectAllVisibleChecked = checked;
      const ids = this.getVisibleFacturaIds();
      if (checked) {
        ids.forEach(id => { if (!this.selectedIds.includes(id)) this.selectedIds.push(id); });
      } else {
        this.selectedIds = this.selectedIds.filter(x => !ids.includes(x));
      }
    },
    async uploadSelectedEFactura() {
      if (!this.selectedIds.length) return;
      this.bulkBusy = true;
      const results = { ok: 0, fail: 0, messages: [] };
      for (const id of this.selectedIds) {
        try {
          const { data } = await axios.post(`/api/anaf/efactura/uploadXML/${id}`);
          if (data && data.status === 'success') {
            results.ok++;
          } else {
            results.fail++;
            results.messages.push(`ID ${id}: ${data?.hint || data?.message || 'upload nereușit'}`);
          }
          await new Promise(r => setTimeout(r, 350));
        } catch (e) {
          results.fail++;
          results.messages.push(`ID ${id}: ${e?.response?.data?.message || e.message || 'eroare necunoscută'}`);
          await new Promise(r => setTimeout(r, 350));
        }
      }
      this.bulkBusy = false;
      if (typeof toast !== 'undefined') {
        toast.fire({ icon: results.fail ? 'warning' : 'success', title: `Upload selectate — reușite: ${results.ok}, eșecuri: ${results.fail}` });
      }
      if (results.messages.length) //console.warn('Detalii upload selectate:', results.messages);
        // reîncarcă tabelul după upload bulk
        if (typeof emitter !== 'undefined' && emitter && typeof emitter.emit === 'function') {
          emitter.emit('AfterCreate');
        }
    },

    // Functii EFactura
    async verificaStareEFactura(idFactura, downloadIfNok = true, suppressAfterCreate = false) {
      const fireToast = (icon, title) => {
        if (typeof toast !== 'undefined' && toast && typeof toast.fire === 'function') {
          toast.fire({ icon, title });
        }
      };
      try {
        // 1) Interogare standard (JSON)
        const { data } = await axios.post(`/api/anaf/efactura/StareFactura/${idFactura}`);

        //console.log('StareMesaj ANAF →', data);

        // deja transmis din backend
        if (data && (data.status === 'info' || data.status === 'success') && /deja transmisa/i.test(String(data.message || ''))) {
          fireToast('info', data.message || 'Factura deja transmisă în e-Factura.');
          return;
        }

        // status generic
        if (!data || !data.status) {
          fireToast('info', 'Răspuns ANAF primit.');
          return;
        }

        if (data.status === 'error') {
          fireToast('error', data?.message || data?.hint || 'Eroare la interogarea stării ANAF.');
          return;
        }

        // status success/info
        const stare = (data?.parsed?.attributes?.stare || data?.stare || '').toString().toLowerCase();
        const idDescarcare = data?.parsed?.attributes?.id_descarcare || data?.id_descarcare || null;

        if (stare === 'ok') {
          fireToast('success', 'ANAF: mesaj procesat cu succes.');
          return;
        }

        if (stare === 'nok') {
          fireToast('warning', idDescarcare ? `Mesaj NOK. id_descarcare: ${idDescarcare}` : 'Mesaj NOK. Se încearcă descărcarea erorilor…');

          if (!downloadIfNok) return;

          // 2) Încearcă download pachet erori
          try {
            const resp = await axios.post(
              `/api/anaf/efactura/StareFactura/${idFactura}?download=1`,
              {},
              { responseType: 'blob' }
            );

            const contentType = (resp.headers['content-type'] || '').toLowerCase();
            const contentDisp = resp.headers['content-disposition'] || '';

            // încearcă să deduci numele fișierului din header
            let filename = '';
            const m = /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(contentDisp);
            if (m) {
              filename = decodeURIComponent(m[1] || m[2] || '');
            }
            if (!filename) {
              filename = `anaf_efact_errors_${idFactura}${contentType.includes('zip') ? '.zip' : '.txt'}`;
            }

            // dacă e ZIP -> descarcă
            if (contentType.includes('application/zip') || filename.toLowerCase().endsWith('.zip')) {
              const url = window.URL.createObjectURL(resp.data);
              const a = document.createElement('a');
              a.href = url;
              a.download = filename;
              document.body.appendChild(a);
              a.click();
              a.remove();
              window.URL.revokeObjectURL(url);

              fireToast('info', 'Pachetul de erori a fost descărcat.');
            } else {
              // alt tip (probabil text/json) – arată în popup + consolă
              const text = await resp.data.text?.() || '';
              //console.log('ANAF NOK (non-zip):', text);

              this.efactPopup.title = 'Detalii ANAF (NOK)';
              this.efactPopup.message = text || 'Răspuns primit, dar nu a fost returnat un ZIP.';
              this.efactPopup.visible = true;

              fireToast('info', 'Detaliile erorii au fost afișate.');
            }
          } catch (e) {
            console.error('Download NOK package failed:', e);
            fireToast('error', e?.response?.data ? 'Nu s-a putut descărca pachetul de erori.' : (e.message || 'Nu s-a putut descărca pachetul de erori.'));
          }
          return;
        }

        // stare necunoscută
        fireToast('info', data?.message || 'Interogare stare finalizată.');
      } catch (err) {
        if (err?.response) {
          console.error('StareMesaj ANAF (HTTP error):', err.response.status, err.response.data);
          const msg = err.response?.data?.message || err.response?.data?.hint || `Eroare HTTP ${err.response.status} la interogarea stării.`;
          fireToast('error', msg);
        } else {
          console.error('StareMesaj ANAF (exception):', err.message);
          fireToast('error', err.message || 'Eroare la interogarea stării.');
        }
      } finally {
        if (!suppressAfterCreate) {
          if (typeof emitter !== 'undefined' && emitter && typeof emitter.emit === 'function') {
            emitter.emit('AfterCreate');
          }
        }
      }
    },
    async uploadXMLEFactura(id) {
      try {
        const { data } = await axios.post(`/api/anaf/efactura/uploadXML/${id}`);
        if (data?.status === 'success') {
          if (typeof toast !== 'undefined') {
            toast.fire({ icon: 'success', title: 'Trimis către ANAF (TEST).' });
          }
          //console.log('EFactura upload TEST:', data);
        } else {
          if (typeof toast !== 'undefined') {
            toast.fire({ icon: 'warning', title: data?.hint || data?.message || 'Upload nereușit.' });
          }
          //console.warn('EFactura upload warn:', data);
        }
      } catch (e) {
        if (typeof toast !== 'undefined') {
          toast.fire({ icon: 'error', title: 'Eroare la upload către ANAF (TEST).' });
        }
        console.error(e);
      } finally {
        // reîncarcă tabelul
        if (typeof emitter !== 'undefined' && emitter && typeof emitter.emit === 'function') {
          emitter.emit('AfterCreate');
        }
      }
    },
    // --- Helpers pentru parsarea/formatatea mesajelor ANAF din campul OBS ---
    safeParseJson(str) {
      try {
        if (typeof str !== 'string') return null;
        return JSON.parse(str);
      } catch (e) { return null; }
    },
    escapeHtml(str) {
      try {
        return String(str)
          .replaceAll('&', '&amp;')
          .replaceAll('<', '&lt;')
          .replaceAll('>', '&gt;')
          .replaceAll('"', '&quot;')
          .replaceAll("'", '&#039;');
      } catch {
        return '';
      }
    },
    buildObsPrettyHtml(obsRaw) {
      // Accept string or object; always stringify safely
      const rawStr = (obsRaw == null) ? '' : (typeof obsRaw === 'string' ? obsRaw : JSON.stringify(obsRaw));
      const raw = rawStr.toString().trim();
      if (!raw) return '<p>Nu există observații.</p>';

      // === 0) Dacă textul din DB este direct XML (ex. "<?xml ...><header .../>") — formatăm pe loc
      const xmlAttrsDirect = this.parseAnafHeaderXml(raw);
      if (xmlAttrsDirect) {
        // Afișăm badge-uri + mesaj prietenos, fără raw XML
        return this.buildAnafHeaderHtml(xmlAttrsDirect) + `<p class="text-muted small mb-0">Răspuns ANAF — atributele principale sunt afișate mai sus.</p>`;
      }

      // 1) Parsează JSON exterior (ex. { status, stare, response, ... })
      const outer = this.safeParseJson(raw) || {};

      // 1.a) Dacă `response` conține XML header ANAF, îl formatezi prioritar
      if (outer && typeof outer.response === 'string') {
        const innerXmlAttrs = this.parseAnafHeaderXml(outer.response);
        if (innerXmlAttrs) {
          // Afișează doar rezumatul prietenos (badge-uri) fără XML-ul brut
          return this.buildAnafHeaderHtml(innerXmlAttrs);
        }
      }

      // 2) Dacă `response` e JSON stringify, parsează-l; altfel, dacă outer are deja Messages, folosește-l
      let inner = outer.response ? this.safeParseJson(outer.response) : null;
      if (!inner && (outer.Messages || outer.messages)) inner = outer;

      const container = inner || {};
      const msgs = Array.isArray(container.Messages)
        ? container.Messages
        : (Array.isArray(container.messages) ? container.messages : []);

      const stare = (outer.stare || container.stare || '').toString().toUpperCase();
      const idInc = outer.id_incarcare || container.id_incarcare || null;
      const idDesc = outer.id_descarcare || container.id_descarcare || null;
      const trace = outer.trace_id || container.trace_id || null;

      // 3) Badge-uri de status
      const badgeStareClass = stare === 'OK' ? 'bg-success' : (stare === 'NOK' ? 'bg-danger' : 'bg-secondary');
      let html = '<div class="efact-badges mb-2">';
      if (stare) html += `<span class="badge ${badgeStareClass} me-2">stare: ${this.escapeHtml(stare)}</span>`;
      if (idInc) html += `<span class="badge bg-secondary me-2">id_incarcare: ${this.escapeHtml(idInc)}</span>`;
      if (idDesc) html += `<span class="badge bg-secondary me-2">id_descarcare: ${this.escapeHtml(idDesc)}</span>`;
      if (trace) html += `<span class="badge bg-light text-dark border me-2">trace_id: ${this.escapeHtml(trace)}</span>`;
      html += '</div>';

      // 4) Mesaje detaliate
      if (msgs.length) {
        html += '<ol class="efact-msg-list">';
        msgs.forEach((m) => {
          const full = typeof m === 'string' ? m : (m?.message || '');
          const cod = /codEroare=([^;]+)/.exec(full)?.[1]?.trim() || '—';
          const text = /textEroare=([^;]+);/.exec(full)?.[1]?.trim() || full;
          const loc = /localizareEroare=([^;]+)/.exec(full)?.[1]?.trim();
          const expr = /expresieValidata=([\s\S]+)$/.exec(full)?.[1]?.trim();

          html += '<li class="mb-2">';
          html += `<div><strong>[${this.escapeHtml(cod)}]</strong> ${this.escapeHtml(text)}</div>`;
          if (loc) html += `<div class="text-muted small">la: ${this.escapeHtml(loc)}</div>`;
          if (expr) html += `<details class="mt-1"><summary>expresieValidata</summary><code class="efact-code">${this.escapeHtml(expr)}</code></details>`;
          html += '</li>';
        });
        html += '</ol>';
        return html;
      }

      // 5) Fallback: afișează raw/response într-o casetă
      if (outer.response && !inner) {
        return `<pre class="efact-code">${this.escapeHtml(outer.response)}</pre>`;
      }
      return `<pre class="efact-code">${this.escapeHtml(raw)}</pre>`;
    },
    parseAnafHeaderXml(xmlStr) {
      try {
        const xml = String(xmlStr || '').trim();
        if (!xml) return null;
        const doc = new DOMParser().parseFromString(xml, 'application/xml');
        const header = doc.getElementsByTagNameNS('mfp:anaf:dgti:efactura:stareMesajFactura:v1', 'header')[0]
          || doc.getElementsByTagName('header')[0];
        if (!header) return null;
        return {
          stare: header.getAttribute('stare') || null,
          id_descarcare: header.getAttribute('id_descarcare') || null,
          id_solicitare: header.getAttribute('id_solicitare') || null,
        };
      } catch {
        return null;
      }
    },
    buildAnafHeaderHtml(attrs) {
      if (!attrs) return '<p>Nu s-au putut extrage atributele din XML.</p>';
      const stare = (attrs.stare || '').toUpperCase();
      const badgeClass = stare === 'OK' ? 'bg-success' : (stare === 'NOK' ? 'bg-danger' : 'bg-secondary');
      let html = '<div class="efact-badges mb-2">';
      if (stare) html += `<span class="badge ${badgeClass} me-2">stare: ${this.escapeHtml(stare)}</span>`;
      if (attrs.id_descarcare) html += `<span class="badge bg-secondary me-2">id_descarcare: ${this.escapeHtml(attrs.id_descarcare)}</span>`;
      if (attrs.id_solicitare) html += `<span class="badge bg-secondary me-2">id_solicitare: ${this.escapeHtml(attrs.id_solicitare)}</span>`;
      html += '</div>';
      return html;
    },
    // Stari EFactura
    showEFactPopup(factura, tip) {
      try {
        const statusLabel = this.eFactStatusBarLabel(factura.anaf_ft_status);
        const uploadLabel = this.eFactUploadBarLabel(factura.anaf_ft_stare_upload);
        const obsStatusRaw = (factura.anaf_ft_obs || '').toString().trim();
        const obsUploadRaw = (factura.anaf_ft_obs_upload || '').toString().trim();

        let title = 'Detalii e-Factura';
        let message = '';

        if (tip === 'upload') {
          title = `Upload e-Factură — ${uploadLabel}`;
          message = obsUploadRaw
            ? this.buildObsPrettyHtml(obsUploadRaw)
            : '<p>Nu există observații pentru upload.</p>';
        } else {
          title = `Status e-Factură — ${statusLabel}`;
          if (obsStatusRaw) {
            message = this.buildObsPrettyHtml(obsStatusRaw);
          } else {
            switch (Number(factura.anaf_ft_status)) {
              case 1: message = '<p>Factura este marcată ca <strong>Transmisă</strong> către e-Factura.</p>'; break;
              case 2: message = '<p><strong>Eroare la trimitere.</strong> Puteți reîncerca.</p>'; break;
              case 3: message = '<p><strong>Eroare de validare XML.</strong> Corectați și reîncercați.</p>'; break;
              default: message = '<p>Factura nu a fost transmisă către e-Factura.</p>'; break;
            }
          }
        }

        this.efactPopup.title = title;
        this.efactPopup.message = message;
        this.efactPopup.visible = true;
      } catch (e) {
        console.error('showEFactPopup error:', e);
        this.efactPopup.title = 'Detalii e-Factura';
        this.efactPopup.message = 'A apărut o eroare la afișarea mesajului.';
        this.efactPopup.visible = true;
      }
    },
    eFactUploadBarLabel(code) {
      switch (Number(code)) {
        case 1: return 'Finalizat';
        case 2: return 'NOK';
        case 3: return 'Prelucrare';
        default: return 'Incarcata';
      }
    },
    eFactUploadBarClass(code) {
      switch (Number(code)) {
        case 1: return 'bg-success';
        case 2: return 'bg-danger';
        case 3: return 'bg-primary';
        default: return 'bg-info';
      }
    },
    eFactStatusBarLabel(code) {
      switch (Number(code)) {
        case 1: return 'Transmis';
        case 2: return 'Eroare trimitere';
        case 3: return 'Eroare XML';
        default: return 'Netransmis';
      }
    },
    eFactStatusBarClass(code) {
      switch (Number(code)) {
        case 1: return 'bg-primary';      // transmis
        case 2: return 'bg-danger';       // eroare trimitere
        case 3: return 'bg-warning';      // eroare validare
        default: return 'bg-secondary';   // netrimis
      }
    },
    // Alt
    produsePeFactura(id) {
      return this.produseFacturi[id] || [];
    },
    // Functie pentru randul expandabil cu detalii produse (HTML detaliat)
    formatFacturaChildRow(factura, produse) {
      const wrapper = document.createElement('div');
      const app = createApp(FacturaChild, {
        factura,
        produse,
        onIncaseaza: (f) => this.deschideModalIncasare(f),
        onEditIncasare: (incasare) => this.deschideModalEditIncasare(incasare),
        onDeleteIncasare: (incasare) => this.confirmaStergereIncasare(incasare)
      });
      app.mount(wrapper);
      return wrapper;
    },
    async incarcaProduseFactura(id) {
      try {
        const response = await axios.get('/api/facturare/incarcaFacturi/' + id);
        this.produseFacturi = {
          ...this.produseFacturi,
          [id]: response.data
        };
        // poți salva datele într-un obiect separat dacă vrei
        // this.produseFacturiNou = { ...this.produseFacturiNou, [id]: response.data };
      } catch (error) {
        console.error(`Eroare la încărcarea produselor pentru factura ${id}:`, error);
      }
    },
    incarcaTabelFacturare() {
      axios.get("/api/facturare/incarcaFacturi")
        .then((response) => {
          this.facturi_emise = response.data;
          this.$nextTick(() => {
            // custom EU date ordering only once
            if (!$.fn.dataTable.ext.type.order['date-eu-pre']) {
              $.fn.dataTable.ext.type.order['date-eu-pre'] = function (date) {
                if (!date) return 0
                const parts = String(date).split('.')
                if (parts.length !== 3) return 0
                return Date.parse(`${parts[2]}-${parts[1]}-${parts[0]}`) // YYYY-MM-DD
              }
            }

            const $table = $('#tabel_facturare')
            // destroy safely if already initialized
            if ($.fn.dataTable.isDataTable($table)) {
              $table.DataTable().clear().destroy()
            }

            const vm = this
            const table = $table.DataTable({
              pageLength: 15,
              lengthChange: true,
              lengthMenu: [[15, 25, 50, 100], [15, 25, 50, 100]],
              stateSave: true,
              stateDuration: -1, // keep indefinitely (localStorage)
              columnDefs: [
                { targets: 1, responsivePriority: 1 },
                { targets: 2, type: 'date-eu' },
              ],
              order: [[2, 'desc'], [3, 'desc']],
              language: { url: 'https://cdn.datatables.net/plug-ins/1.11.3/i18n/ro.json' },
              paging: true,
              pagingType: 'full_numbers',
              ordering: true,
              info: true,
              searching: true,
              responsive: false,
              createdRow: function (row, data, dataIndex) {
                const factura = vm.facturi_emise[dataIndex]
                if (factura && factura.id) {
                  $(row).addClass(`row-factura-${factura.id}`)
                } else {
                  //console.warn('Factura ID not found for dataIndex:', dataIndex, data)
                }
              },
            })

            // re‑hook KTMenu after draws
            this.$nextTick(() => this.initKTMenus())
            table.on('draw.dt', () => {
              this.$nextTick(() => this.initKTMenus())
            })
          })
        })
    },
    toggleFacturaDetails(factura) {
      const table = $('#tabel_facturare').DataTable();
      const tr = $(`.row-factura-${factura.id}`);
      const row = table.row(tr);

      if (row.child.isShown()) {
        row.child.hide();
        tr.removeClass('shown');
        this.expandedRows = this.expandedRows.filter(id => id !== factura.id);
      } else {
        if (!this.produseFacturi[factura.id]) {
          this.incarcaProduseFactura(factura.id).then(() => {
            const produse = this.produseFacturi[factura.id] || [];
            row.child(this.formatFacturaChildRow(factura, produse)).show();
            tr.addClass('shown');
            if (!this.expandedRows.includes(factura.id)) {
              this.expandedRows.push(factura.id);
            }
          });
        } else {
          const produse = this.produseFacturi[factura.id] || [];
          row.child(this.formatFacturaChildRow(factura, produse)).show();
          tr.addClass('shown');
          if (!this.expandedRows.includes(factura.id)) {
            this.expandedRows.push(factura.id);
          }
        }
      }
    },
    handleRenuntaFactura() {
      this.afiseazaFormularFactura = false;
      this.afiseazaTabel = true;
      //this.incarcaTabelFacturare(); // dacă vrei să reîncarci și datele
    },
  },
  computed: {
    expandedFacturi() {
      return this.facturi_emise.filter(factura => this.expandedRows.includes(factura.id));
    },
    canBulkUpdate() {
      const rows = this.selectedRows();
      return rows.length > 0 && rows.every(this.isEligibleForUpdate);
    },
    canBulkUpload() {
      const rows = this.selectedRows();
      return rows.length > 0 && rows.every(this.isEligibleForUpload);
    },
  },
  created() {
    //console.log(this.$gate.firma_curenta); // ar trebui să fie null dacă nu e setată
    //console.log(this.$gate.areFirmaSelectata()); // trebuie să fie false dacă firma_curenta e null
    emitter.on('searching', () => {//search
      let query = this.$parent.search;
      axios.get('/api/utile/cautareDosare?cD=' + query)
        .then((data) => {
          this.dosare = data.data
        })
        .catch(() => {
          console.log('eroare la cautare');
        })
    })
    this.incarcaTabelFacturare();
    emitter.on('AfterCreate', () => {
      $('#tabel_facturare').DataTable().destroy();
      this.incarcaTabelFacturare();
    });
  },
  mounted() {
    document.addEventListener('click', this.handleDocumentClick);
    this.$nextTick(() => this.initKTMenus());
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleDocumentClick);
  },
  activated() {
    //this.$nextTick(() => this.initKTMenus());
  },

}

</script>


<style lang="scss" scoped>
.icon-mare {
  font-size: 24px
}

#tabel_facturare {
  font-size: 14px;
}

#tabel_facturare th,
#tabel_facturare td {
  padding: 4px 6px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#tabel_facturare th:first-child,
#tabel_facturare td:first-child {
  width: 32px;
}

.fas {
  transition: transform 0.3s ease;
}

.rotate-up {
  transform: rotate(180deg);
}

.rotate-down {
  transform: rotate(0deg);
}

#tabel_facturare tbody tr {
  border-bottom: 2px solid #bdbdbd;
}

#tabel_facturare tbody tr:not(.child):hover {
  background-color: #d4f8dd !important;
}

#tabel_facturare tbody tr.shown {
  background-color: #e0ffe0 !important;
  /* Verde deschis sau orice vrei */
}

.efact-clickable {
  cursor: pointer;
}

.efact-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.efact-modal {
  background: #fff;
  border-radius: .5rem;
  width: min(720px, 96vw);
  max-height: 80vh;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  padding: 1rem 1rem 0.75rem;
  display: flex;
  flex-direction: column;
}

.efact-modal-header {
  border-bottom: 1px solid #eee;
  padding-bottom: .5rem;
  margin-bottom: .75rem;
}

.efact-modal-body {
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 0.95rem;
}

.efact-modal-footer {
  border-top: 1px solid #eee;
  padding-top: .5rem;
}

.efact-badges .badge {
  margin-right: .5rem;
}

.efact-msg-list {
  padding-left: 1.25rem;
  margin: .5rem 0;
}

.efact-msg-list li {
  margin-bottom: .5rem;
}

.efact-code {
  display: block;
  background: #f8f9fa;
  padding: .5rem .75rem;
  border-radius: .25rem;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
}


/* Tighter cells for selection + TVA-I columns (1st and 12th) */
#tabel_facturare th:nth-child(1),
#tabel_facturare td:nth-child(1),
#tabel_facturare th:nth-child(12),
#tabel_facturare td:nth-child(12) {
  padding-left: 2px !important;
  padding-right: 2px !important;
  width: 28px;
  /* keep narrow */
}

/* Remove default Bootstrap .form-check extra spacing inside table */
#tabel_facturare .form-check {
  padding-left: 0;
  /* kill left indent */
  min-height: 0;
  /* prevent tall rows */
  margin: 0;
  /* no outer margin */
}

#tabel_facturare .form-check-input {
  position: static;
  /* avoid absolute offsets */
  margin: 0;
  /* center via parent text-center */
  line-height: 1;
  /* compact */
}



/* Make Acțiuni column fit button size */
#tabel_facturare th:last-child,
#tabel_facturare td:last-child {
  width: 1%;
  white-space: nowrap;
}

#tabel_facturare td:last-child .btn {
  min-width: auto;
}
</style>
